<template>
  <button type="button" class="highlight-panel" @click="openDetail">
    <span class="content">
      <slot></slot>
    </span>
    <span class="icon">
      <chevron-right></chevron-right>
    </span>
  </button>
  <div class="detail" v-if="detailVisible">
    <div class="content">
      <slot name="detail"></slot>
    </div>
    <div class="actions">
      <button @click="close">Fermer</button>
    </div>
  </div>
</template>

<script>
import {ChevronRight} from "mdue"

export default {
  name: "HighlightPanel",
  components: {ChevronRight},
  data() {
    return {
      detailVisible: false,
      id: "highlight"
    }
  },
  watch: {
    '$route.query.detail': {
      immediate: true,
      handler(val) {
        this.detailVisible = val === this.id;
      }
    }
  },
  methods: {
    openDetail(){
      this.detailVisible = true;
      this.$router.push({ query: { ...this.$route.query, detail: this.id } });
    },
    close(){
      this.detailVisible = false;
      const newQuery = { ...this.$route.query };
      delete newQuery.detail;
      this.$router.push({ query: newQuery });
    }
  }
}
</script>



<style scoped lang="css">
.highlight-panel {
  padding: 16px;
  border-radius: 6px;
  display: flex;
  column-gap: 10px;
  align-items: center;

  justify-content: space-between;

  color: #c3524f;;

  background: white none;
  margin-top: 0;
}

.highlight-panel span{
  display: block;
  text-align: left;
}

.icon{
  min-width: fit-content;
}

.detail{
  display: flex
;
  flex-direction: column;
  justify-content: space-between;
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: white;
  z-index: 100;
}

.detail > div{
  padding: 20px;
}

.detail > .content{
  overflow-x: hidden;
  overflow-y: auto;
}

.detail > .actions{
  display: flex;
  justify-content: right;
}

.detail > .actions button{
  margin: 0;
}

</style>